import React, { useEffect, useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { AudienceSection } from '../components/AudienceSection';
import { SolutionSection } from '../components/SolutionSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { Button } from '../components/ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift } from 'lucide-react';
export function SalesPage() {
  const [showBar, setShowBar] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShowBar(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen flex flex-col" data-id="element-250">
      {/* ═══════════════════════════════════ */}
      {/* BLOQUE 1: PROMESA                  */}
      {/* ═══════════════════════════════════ */}
      <HeroSection data-id="element-251" />

      {/* ═══════════════════════════════════ */}
      {/* BLOQUE 2: DOLORES                  */}
      {/* ═══════════════════════════════════ */}
      <ProblemSection data-id="element-252" />
      <AudienceSection data-id="element-253" />

      {/* ═══════════════════════════════════ */}
      {/* BLOQUE 3: BENEFICIOS               */}
      {/* ═══════════════════════════════════ */}
      <SolutionSection data-id="element-254" />
      <FeaturesSection data-id="element-255" />
      <BonusSection data-id="element-256" />

      {/* ═══════════════════════════════════ */}
      {/* CIERRE: PRECIO + FAQ + FOOTER      */}
      {/* ═══════════════════════════════════ */}
      <PricingSection data-id="element-257" />
      <TestimonialsSection data-id="element-258" />
      <FAQSection data-id="element-259" />

      {/* Final Emotional Close */}
      <section className="bg-[#1B4332] relative overflow-hidden" data-id="element-260">
        <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/paper.png')] pointer-events-none" data-id="element-261" />
        <div className="relative z-10 max-w-2xl mx-auto text-center py-16 px-6" data-id="element-262">
          <p className="text-[#C9963A] font-bold text-sm uppercase tracking-widest mb-4" data-id="element-263">
            Una última cosa
          </p>
          <h2 className="text-3xl md:text-4xl font-serif text-[#FDF8F0] mb-5 leading-snug" data-id="element-264">
            La próxima vez que te sientas mal a las 11 de la noche…
          </h2>
          <p className="text-lg text-[#FDF8F0]/80 leading-relaxed mb-3" data-id="element-265">
            Vas a poder abrir una ficha, seguir 3 pasos claros, mirar el
            semáforo y decidir con calma.
          </p>
          <p className="text-xl text-[#FDF8F0] font-serif italic mb-8" data-id="element-266">
            Sin Google. Sin pánico. Sin improvisar.
          </p>

          <Button size="lg" className="text-lg shadow-xl shadow-[#C9963A]/30" onClick={() => window.open('https://factorclaro.com/cart/45270142386355:1', '_self')} data-id="element-267">
            QUIERO ESA TRANQUILIDAD
          </Button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0F2B1E] text-[#FDF8F0]/40 py-6 px-6 text-center text-xs" data-id="element-268">
        <p data-id="element-269">
          © {new Date().getFullYear()} Botiquín Natural Responsable. Todos los
          derechos reservados.
        </p>
        <p className="mt-1" data-id="element-270">
          Este producto es una guía educativa y no reemplaza el consejo médico
          profesional.
        </p>
      </footer>

      {/* Sticky Bottom Bar */}
      <AnimatePresence data-id="element-271">
        {showBar && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} className="fixed bottom-0 left-0 right-0 z-50" data-id="element-272">
            <div className="bg-[#1B4332]/90 backdrop-blur-md border-t border-[#C9963A]/30 px-3 py-1.5" data-id="element-273">
              <div className="max-w-3xl mx-auto flex items-center justify-between gap-2" data-id="element-274">
                <div className="flex items-center gap-1.5 min-w-0" data-id="element-275">
                  <Gift className="w-3.5 h-3.5 text-[#C9963A] flex-shrink-0" data-id="element-276" />
                  <p className="text-[#FDF8F0] text-[11px] sm:text-xs truncate tracking-wide" data-id="element-277">
                    <span className="font-bold text-[#C9963A] drop-shadow-[0_0_6px_rgba(201,150,58,0.5)]" data-id="element-278">
                      50% OFF
                    </span>
                    <span className="hidden sm:inline" data-id="element-279">
                      {' '}
                      + 10 bonos de regalo ✨
                    </span>
                    <span className="sm:hidden" data-id="element-280"> + 10 bonos ✨</span>
                  </p>
                </div>
                <button onClick={() => window.open('https://factorclaro.com/cart/45270142386355:1', '_self')} className="flex-shrink-0 bg-[#C9963A] hover:bg-[#D4A843] text-white text-[11px] sm:text-xs font-bold px-3 py-1.5 rounded-md transition-all whitespace-nowrap shadow-[0_0_12px_rgba(201,150,58,0.35)] hover:shadow-[0_0_18px_rgba(201,150,58,0.5)]" data-id="element-281">
                  Comprar Ahora
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}